import { NgModule } from '@angular/core';
import { TimerDirective } from './timer.directive';



@NgModule({
  declarations: [
    TimerDirective,
  ],
  imports: [
  ],
  exports: [
    TimerDirective,
  ]
})
export class TlTimerModule { }
